export default "__VITE_ASSET___abe6WEP__"